import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
  selector: "formly-field-editor",
  /*'avoid-edit': field.templateOptions.disabled*/
  template: `
    <div
      [ngClass]="{
        'border-danger': formControl.errors && formControl.touched,
        disabled: field.templateOptions.disabled
      }"
      style="border: 1px solid transparent;
    padding: 0 0.1rem 0 0;"
    >
      <app-editor
        [elementId]="field.id"
        [dataForm]="formControl.value"
        [disabled]="field.templateOptions.disabled"
        (notify)="
          formControl.patchValue($event.id); formControl.markAsTouched()
        "
      ></app-editor>
      <!-- {{ field.templateOptions | json }} -->
    </div>
  `,
})
export class FormlyFieldEditor extends FieldType<FieldTypeConfig> {}
